/**
 * Enumeration to list all possible types for an order
 */
export enum SourceType  {
  OKTO = 'okto',
  MULTIPRESS = 'multipress',
}
